import React from "react";

import PageHeader from "../../../../componets/PageHeader";
import NavBarThree from "../../../../componets/NavBarThree";
import { PlusOutlined, SettingOutlined } from "@ant-design/icons";
import {CategoryInterface, setNewParams, setReorderIds} from "../../../../store/roblox/categoriesSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { selectCategoryIds } from "../../../../store/roblox/categoriesSlice";
import NavBarTwo, {parentInterface} from "../../../../componets/NavBarTwo";
import {useLocation} from "react-router-dom";

interface PropsInterface {
  title: string;
  navs: {[index: number]: any};
  parent?: parentInterface;
  target?: CategoryInterface['target'];
}

const _PageHeader = ({ title, navs, parent, target }: PropsInterface) => {
  const dispatch      = useAppDispatch();
  const ids = useAppSelector(selectCategoryIds);
  const { pathname }  = useLocation();
  const activeItem    = Object.values(navs).find(e => e.url === pathname);

  function onClickCreate() {
    dispatch(setNewParams({ target: target }));
  }

  function onClickSettings() {
    dispatch(setReorderIds({ ids }));
  }

  return (
    <PageHeader
      title={title}
      breadcrumbs={[activeItem?.name]}
    >
      <NavBarTwo
        items={navs}
        itemIds={Object.keys(navs)}
        activeId={activeItem?.id}
        parent={parent}
      />

      <NavBarThree>
        <NavBarThree.Button onClick={onClickSettings}>
          <SettingOutlined /> Category Settings
        </NavBarThree.Button>
        <NavBarThree.Button onClick={onClickCreate}>
          <PlusOutlined /> Create Category
        </NavBarThree.Button>
      </NavBarThree>
    </PageHeader>
  );
}

export default _PageHeader;
